module.exports = __webpack_public_path__ + "img/kiki - 에볼루션.79889070.png";